import e from "./LinkButton.vue.js";
import { useLocalization as t } from "./localization/index.js";
import { createElementBlock as n, createElementVNode as r, createTextVNode as i, createVNode as a, defineComponent as o, normalizeClass as s, openBlock as c, ref as l, toDisplayString as u, unref as d, withCtx as f } from "vue";
import { ScalarIcon as p } from "@scalar/components/icon";
import { useClipboard as m } from "@scalar/use-hooks/useClipboard";
import { onClickOutside as h, onKeyStroke as g } from "@vueuse/core";
//#region src/schema/SchemaPropertyPattern.vue?vue&type=script&setup=true&lang.ts
var _ = { class: "property-pattern-popup" }, v = ["aria-label"], y = /*@__PURE__*/ o({
	__name: "SchemaPropertyPattern",
	props: { pattern: {} },
	setup(o) {
		let { copyToClipboard: y } = m(), { translate: b } = t(), x = l(null), S = l(!1), C = () => {
			S.value = !S.value;
		}, w = () => {
			S.value = !1;
		};
		return h(x, w), g("Escape", () => {
			S.value && w();
		}), (t, l) => (c(), n("div", {
			ref_key: "rootRef",
			ref: x,
			class: s(["property-pattern", { "is-open": S.value }])
		}, [a(e, {
			class: "decoration-dotted",
			onClick: C
		}, {
			default: f(() => [i(u(d(b)("schema.pattern")), 1)]),
			_: 1
		}), r("div", _, [r("button", {
			"aria-label": `${d(b)("schema.copyPattern")}: ${o.pattern}`,
			class: "property-pattern-value group",
			type: "button",
			onClick: l[0] ||= (e) => d(y)(o.pattern)
		}, [r("code", null, u(o.pattern), 1), a(d(p), {
			"aria-hidden": "true",
			class: "group-hover:text-c-1 text-c-3 ml-auto min-h-3 min-w-3",
			icon: "Clipboard",
			size: "xs"
		})], 8, v)])], 2));
	}
});
//#endregion
export { y as default };

//# sourceMappingURL=SchemaPropertyPattern.vue_vue_type_script_setup_true_lang.js.map